import { render, staticRenderFns } from "./ListProductBatchStockHistory.vue?vue&type=template&id=c2e79ef8&scoped=true"
import script from "./ListProductBatchStockHistory.vue?vue&type=script&lang=js"
export * from "./ListProductBatchStockHistory.vue?vue&type=script&lang=js"
import style0 from "./ListProductBatchStockHistory.vue?vue&type=style&index=0&id=c2e79ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e79ef8",
  null
  
)

export default component.exports